import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example1" }),
  /*#__PURE__*/_createTextVNode(" Field-level Validation ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" You can define validation rules for your fields using the "),
  /*#__PURE__*/_createVNode("b", null, "useField"),
  /*#__PURE__*/_createTextVNode(" composition API function, your rules can be as simple as a function that accepts the current value and returns an error message. ")
], -1)
const _hoisted_5 = { class: "rounded border p-10 my-10" }
const _hoisted_6 = { class: "text-danger" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The validation happens automatically when "),
  /*#__PURE__*/_createVNode("b", null, "value"),
  /*#__PURE__*/_createTextVNode(" binding changes, meaning you can use "),
  /*#__PURE__*/_createVNode("b", null, "useField"),
  /*#__PURE__*/_createTextVNode(" to trigger validation for any kind of data and not just for inputs. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
          type: "text",
          class: "form-control form-control-solid",
          id: "example1VeeValidate",
          placeholder: "Interact with this field"
        }, null, 512), [
          [_vModelText, _ctx.value]
        ]),
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1),
        _createVNode(_component_CodeHighlighter2, null, {
          html: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example1Html), 1)
          ]),
          js: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example1Js), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ])
  ]))
}